window.heistAnalytics = {
  itemFromElement(el) {
    if (!el || !el.dataset.gaItemId) return null;

    const { dataset } = el;
    return {
      item_id: dataset.gaItemId,
      item_name: dataset.gaItemName,
      item_brand: dataset.gaItemBrand,
      item_category: dataset.gaItemCategory,
      item_variant: dataset.gaItemVariant,
      price: Number(dataset.gaPrice) / 100,
      discount: Number(dataset.gaDiscount) / 100,
    };
  },

  pushRemoveFromCart(item, removedQty) {
    if (!item || !(removedQty > 0)) return;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          currency: window.Shopify?.currency?.active,
          value: Number((item.price * removedQty).toFixed(2)),
          items: [{ ...item, quantity: removedQty }],
        },
      });
    } catch (error) {
      console.warn("[analytics] remove_from_cart push failed", error);
    }
  },
};
